import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IResultroleszModel, ResultroleszModel } from 'src/app/models/accounts/role.model';

@Injectable({
  providedIn: 'root'
})
export class roleszService {
  private API_URL = `${environment.apiUrl}/security/roles/`;

  constructor(private http: HttpClient) {}

  getroleslist(practiceId: string): Observable<ResultroleszModel> {
    const params = new HttpParams().set('practice_required', "true").set('is_invitation', "true");
    return this.getroles(params);
    //return this.http.get<ResultroleszModel>(`${environment.apiAuthUrl}/security/roles/`, { params });
  }
  getroles(params:HttpParams): Observable<ResultroleszModel> {
    return this.http.get<ResultroleszModel>(`${environment.apiAuthUrl}/security/roles/`, { params });
  }

    // Function to call the resend invitation API
    changuserrole(id: any,roleid:any,practiceId:any): Observable<any> {
        const url = `${environment.apiUrl}/accounts/account_list/${id}/change_role/?practice_id=${practiceId}`;
        return this.http.post(url, {'role_id': roleid.toString()});  // Send a POST request with an empty body
      }

      // Function to call the cancel invitation API


}
